import React, {Component, Fragment} from 'react';
import get from 'lodash/get';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import ExpressionContainer from './ExpressionContainer';
import * as constants from '../../../constants';
import PlusButton from './PlusButton';
import LogicOp from './LogicOp';
import MinusButton from './MinusButton';
import TooltipIcon from '../../TooltipIcon';

class ExpressionType extends Component {
    constructor(props) {
        super(props);
        this.addExpression = this.addExpression.bind(this);
        this.addGroup = this.addGroup.bind(this);
        this.removeExpression = this.removeExpression.bind(this);
        this.removeGroup = this.removeGroup.bind(this);
    }

    addExpression() {
        this.props.push({id: '', logicOp: constants.LOGIC_OP_AND, condition: {operator: '', value: '', question: ''}});
    }

    addGroup() {
        this.props.push({logicOp: constants.LOGIC_OP_AND, conditions: []});
    }

    removeExpression(index) {
        this.props.remove(index);
    }

    removeGroup() {
        this.props.removeGroup();
    }

    render() {
        const {form, field, previousPages, items, extraFields, parameters} = this.props;
        const name = field.name;

        return (
            <Fragment>
                {get(form.values, name) && get(form.values, name).map((k, index, arr) => (
                    <div key={index} className="ml-3">
                        <ExpressionContainer items={items} name={name} form={form} k={k} index={index} previousPages={previousPages}
                            remove={this.removeExpression} extraFields={extraFields} parameters={parameters} />
                        {index < arr.length - 1 &&
                            <div className="my-3">
                                <LogicOp id={`${name}.${index}.logicOp`} name={`${name}.${index}.logicOp`} />
                            </div>
                        }
                    </div>
                ))}
                <div className="ml-3 mt-2">
                    <div className="d-flex">
                        <div className="mr-auto">
                            <PlusButton onClick={this.addExpression}>
                                <FormattedMessage {...messages.jumps.button.addExpression} />
                                {' '}
                                <TooltipIcon message={messages.jumps.tooltip.addExpression} />
                            </PlusButton>
                            <PlusButton className="ml-2" onClick={this.addGroup}>
                                <FormattedMessage {...messages.jumps.button.addGroup} />
                                {' '}
                                <TooltipIcon message={messages.jumps.tooltip.addGroup} />
                            </PlusButton>
                        </div>
                        {this.props.removeGroup !== undefined &&
                            <MinusButton remove={this.removeGroup}><FormattedMessage {...messages.jumps.button.removeGroup} /></MinusButton>
                        }
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default ExpressionType;
